import {
  TransactionStatus,
  TransactionType,
  BusinessVerificationStatus,
  PersonalVerificationStatus,
} from '~/types'

export type BusinessAccount = {
  generalWallet: {
    availableBalance: string
    holdingBalance?: string
    fundPoolId?: number
  } | null
  digitalGoodsWallet: {
    availableBalance: string
    holdingBalance?: string
    fundPoolId?: number
  } | null
}

export type CorporateAccount = {
  generalWallet: {
    availableBalance: string
  } | null
  digitalGoodsWallet: {
    availableBalance: string
  } | null
}

export type Transaction = {
  amount: {
    prefix: string
    postfix: string
  }
  created_at: string
  transaction_status: TransactionStatus
  transaction_type: TransactionType
  description: {
    data: string
    direction: 'from' | 'to'
    type: TransactionType
  }
}

export type ManagedAccount = {
  account_title: string
  availableBalance: string
}

export type TransferInfo = {
  recipientName: string
  recipientBankName: string
  recipientAccountNo: string
  referenceNumber?: string
  expiredDate?: string
}

export type DashboardBanner = {
  title: string
  tag: string
  content: string
}

export enum LANDING_PAGE_ACTIONS {
  SET_USER_INFO = 'LANDING_PAGE_ACTIONS.SET_USER_INFO',
  SET_TEMP_HOLDING_BALANCE = 'LANDING_PAGE_ACTIONS.SET_TEMP_HOLDING_BALANCE',
  SET_BUSINESS_ACCOUNT = 'LANDING_PAGE_ACTIONS.SET_BUSINESS_ACCOUNT',
  SET_LATEST_BUSINESS_TRANSACTIONS = 'LANDING_PAGE_ACTIONS.SET_LATEST_BUSINESS_TRANSACTIONS',
  SET_CORPORATE_ACCOUNT = 'LANDING_PAGE_ACTIONS.SET_CORPORATE_ACCOUNT',
  SET_MANAGED_ACCOUNTS = 'LANDING_PAGE_ACTIONS.SET_MANAGED_ACCOUNTS',
  SET_BUSINESS_VERIFICATION_STATUS = 'LANDING_PAGE_ACTIONS.SET_BUSINESS_VERIFICATION_STATUS',
  SET_IS_ERC20_ENABLED = 'LANDING_PAGE_ACTIONS.SET_IS_ERC20_ENABLED',
  SET_IS_ZRC2_ENABLED = 'LANDING_PAGE_ACTIONS.SET_IS_ZRC2_ENABLED',
  SET_IS_ZRC2_NOTICE_BANNER_VISIBLE = 'LANDING_PAGE_ACTIONS.SET_IS_ZRC2_NOTICE_BANNER_VISIBLE',
  SET_IS_LONGER_PROCESSING_NOTICE_BANNER_VISIBLE = 'LANDING_PAGE_ACTIONS.SET_IS_LONGER_PROCESSING_NOTICE_BANNER_VISIBLE',
  SET_IS_VA_ENABLED = 'LANDING_PAGE_ACTIONS.SET_IS_VA_ENABLED',
  SET_TRANSFER_INFO = 'LANDING_PAGE_ACTIONS.SET_TRANSFER_INFO',
  SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED = 'LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED',
  SET_DASHBOARD_BANNERS = 'ROUTE_ACTIONS.SET_DASHBOARD_BANNERS',
}

type SetUserInfo = {
  type: typeof LANDING_PAGE_ACTIONS.SET_USER_INFO
  name: string
  verificationStatus: PersonalVerificationStatus
}

type SetBusinessAccount = {
  type: typeof LANDING_PAGE_ACTIONS.SET_BUSINESS_ACCOUNT
  businessAccount: BusinessAccount
}

type SetLatestBusinessTransactions = {
  type: typeof LANDING_PAGE_ACTIONS.SET_LATEST_BUSINESS_TRANSACTIONS
  latestBusinessTransactions: Transaction[]
}

type SetCorporateAccount = {
  type: typeof LANDING_PAGE_ACTIONS.SET_CORPORATE_ACCOUNT
  corporateAccount: CorporateAccount
}

type SetManagedAccounts = {
  type: typeof LANDING_PAGE_ACTIONS.SET_MANAGED_ACCOUNTS
  managedAccounts: ManagedAccount[]
}

type SetBusinessVerificationStatus = {
  type: typeof LANDING_PAGE_ACTIONS.SET_BUSINESS_VERIFICATION_STATUS
  businessVerificationStatus: BusinessVerificationStatus
}

type SetIsErc20Enabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_ERC20_ENABLED
  isErc20Enabled: boolean
}

type SetIsZrc2Enabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_ZRC2_ENABLED
  isZrc2Enabled: boolean
}

type SetIsZrc2NoticeBannerEnabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_ZRC2_NOTICE_BANNER_VISIBLE
  isZrc2NoticeBannerVisible: boolean
}

type SetIsLongerProcessingNoticeBannerEnabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_LONGER_PROCESSING_NOTICE_BANNER_VISIBLE
  isLongerProcessingNoticeBannerVisible: boolean
}

type SetIsVAEnabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_VA_ENABLED
  isVAEnabled: boolean
}

type SetTransferInfo = {
  type: typeof LANDING_PAGE_ACTIONS.SET_TRANSFER_INFO
  transferInfo: TransferInfo
}

type SetDashboardBanners = {
  type: typeof LANDING_PAGE_ACTIONS.SET_DASHBOARD_BANNERS
  dashboardBanners: DashboardBanner[]
}

type SetIsDashboardBannerManagementEnabled = {
  type: typeof LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED
  isDashboardBannerManagementEnabled: boolean
}

export type ActionTypes =
  | SetUserInfo
  | SetBusinessAccount
  | SetLatestBusinessTransactions
  | SetCorporateAccount
  | SetManagedAccounts
  | SetBusinessVerificationStatus
  | SetIsErc20Enabled
  | SetIsZrc2Enabled
  | SetIsZrc2NoticeBannerEnabled
  | SetIsLongerProcessingNoticeBannerEnabled
  | SetIsVAEnabled
  | SetTransferInfo
  | SetIsDashboardBannerManagementEnabled
  | SetDashboardBanners
